import { useGetSite } from 'api/sites';
import { DEFAULT_CURRENCY_SYMBOL } from 'utils/priceFormatter';
import useTenantSelection from 'hooks/useTenantSelection';

/**
 * The currency symbol configured on the selected site.
 *
 * Currency is a site setting, so anything showing money depends on the header's site selection.
 * Centralised here so callers don't each repeat the `useGetSite(...)?.siteSettings.currencySymbol`
 * lookup and its fallback — and so they all fall back to the same thing when no site is selected
 * or its settings haven't loaded.
 */
export default function useSiteCurrency(): string {
  const { selectedCompanySiteResult } = useTenantSelection();
  const { site } = useGetSite(selectedCompanySiteResult?.siteId ?? null);

  return site?.siteSettings?.currencySymbol || DEFAULT_CURRENCY_SYMBOL;
}
